module.exports = __webpack_public_path__ + "img/MUIC_APP_512_02.a0806bd8.png";